import classNames from "classnames";
import { CSSProperties, useMemo } from "react";
import { Variable } from "../../models/interactions/Variable";
import { richTextToEditorHtml } from "./RichTextHtmlUtils";
import "./RichTextEditor.css";

interface RichTextViewProps {
  /** A stored canonical rich text value (see RichTextHtmlUtils.ts). */
  value: string;
  variables: Variable[];
  className?: string;
  style?: CSSProperties;
}

/**
 * Read-only counterpart of RichTextEditor: renders a stored value as formatted
 * text with variable tokens shown as chips. Used wherever a message is
 * displayed rather than edited - a rich text value shown through {value} would
 * otherwise read out its own markup.
 *
 * The markup is the sanitized output of richTextToEditorHtml, which is the same
 * function the editor writes into its own contentEditable, so a preview and its
 * editor can never render the same value differently.
 */
export default function RichTextView({
  value,
  variables,
  className,
  style,
}: RichTextViewProps) {
  const html = useMemo(
    () => richTextToEditorHtml(value, variables).html,
    [value, variables]
  );

  return (
    <div
      className={classNames("rich-text-view", className)}
      style={style}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
